import { Chip } from '@mui/material'
import { SmallCard } from 'Components/Cards/Small'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { type programSummary } from 'core/types'

export function EnrollmentCard (props: { maxCapacity: number, enrollments: programSummary[] }): JSX.Element {
  const badges = props.enrollments.map((enrollment) => {
    const colorItem = enrollment.id % 3
    let indicatorClass = 'cyan-'
    if (colorItem === 1) {
      indicatorClass = 'purple-'
    } else if (colorItem === 2) {
      indicatorClass = 'red-'
    }
    return <Chip key={enrollment.name + indicatorClass} icon={<FiberManualRecordIcon className={indicatorClass + 'icon'} />} label={enrollment.seats} size='small' className={indicatorClass + 'indicator'} />
  })

  return (<SmallCard
    header={'Enrollments by Type'}
    totalValue={props.enrollments.reduce((a, b) => a + b.seats, 0)}
    currentValue={props.enrollments.reduce((a, b) => a + b.filledSeats, 0)}
    badges={<>{badges}</>}
    onClick={() => { }}
  />)
}
